import React from 'react'
import Header from './Header'
import LessonCardClosed from './LessonCardClosed'
import LessonCard from './LessonCard'
import Modal from './Modal'


class Course extends React.Component{
    
    constructor(props) {
        super(props);
        this.state = {
            display: false,
        };
        this.onShowModal = this.onShowModal.bind(this)
      }
   

    onShowModal(){
        const {display} = this.state
        this.setState({display: !display})
        console.log(this.state.display)
    }


    render(){
        return(
            <div>   
                <Header/>
                <div className='progres'>
                    <div className='progres__text'>
                        <p>Пройдено</p>
                        <p><span>0</span>%</p>
                    </div>
                    <div className='progres__line'>

                    </div>
                </div>
                <main className='main__course'>
                    <h2 className='sub__title'>Уроки</h2>
                    <ul>
                        <LessonCard onShowModal={this.onShowModal} />
                        {this.state.display ? (<Modal/>) : null}
                        <LessonCardClosed/>
                        <LessonCardClosed/>
                        <LessonCardClosed/>
                        <LessonCardClosed/>
                    </ul>
                </main>
            </div>
        )
    }
}


export default Course